/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Selected_AriaInputs */

const en_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Selected`)
};

const fr_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la selection`)
};

const de_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte löschen`)
};

const it_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina selezionato`)
};

const ru_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранное`)
};

const es_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar seleccionados`)
};

const zh_cn2_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除所选内容`)
};

const ja_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択項目を削除`)
};

const hi_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित को हटाओ`)
};

const pt_pt2_explorer_display_delete_selected_aria = /** @type {(inputs: Explorer_Display_Delete_Selected_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir selecionados`)
};

/**
* | output |
* | --- |
* | "Delete Selected" |
*
* @param {Explorer_Display_Delete_Selected_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_selected_aria = /** @type {((inputs?: Explorer_Display_Delete_Selected_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Selected_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_selected_aria(inputs)
	if (locale === "de") return de_explorer_display_delete_selected_aria(inputs)
	if (locale === "it") return it_explorer_display_delete_selected_aria(inputs)
	if (locale === "ru") return ru_explorer_display_delete_selected_aria(inputs)
	if (locale === "es") return es_explorer_display_delete_selected_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_selected_aria(inputs)
	if (locale === "ja") return ja_explorer_display_delete_selected_aria(inputs)
	if (locale === "hi") return hi_explorer_display_delete_selected_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_selected_aria(inputs)
	return en_explorer_display_delete_selected_aria(inputs)
});